'use client';

import React__default from 'react';
import { TravelLineContainer } from './styles.js';

/*
    How to use:
    TravelLineContainer receive children with format:
    <div> -> block line
        <div /> -> icon of block on left side
        <div /> -> content of block on right side
    </div>
    <div> ->
        <div />
        <div />
    </div>
    <div> ->
        <div />
        <div />
    </div>
*/
var TravelLine = function (_a) {
    var children = _a.children, widthIcon = _a.widthIcon, _b = _a.gap, gap = _b === void 0 ? 20 : _b, _c = _a.positionTopIcon, positionTopIcon = _c === void 0 ? 5 : _c;
    return (React__default.createElement(TravelLineContainer, { widthIcon: widthIcon, gap: gap, positionTopIcon: positionTopIcon }, children));
};

export { TravelLine as default };
//# sourceMappingURL=index.js.map
